import Active from './Active';
import Inactive from './Inactive';
const CampaignStatus = {
    Active,
    Inactive,
};
export default CampaignStatus;
